<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div>
<form (ngSubmit)="submitText()" [formGroup]="markupText">
    <mat-dialog-content>
        <mat-form-field>
            <input matInput placeholder="Enter markup text" formControlName="textControl" />
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button type="submit">Submit</button>
        <button mat-button type="button" (click)="cancel()">Cancel</button>
    </mat-dialog-actions>
</form>
</div>
